import { Button, Flex } from "antd";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../../../../common/components/icons/AntIcon";
import styles from "../../statistics/DashboardStatisticsWidget.module.scss";
import { StatNumber } from "./common/StatNumber";
import { STATS_HEIGHT } from "./common/utils";

type Props = {
  data: { commissionsActiveStatePoints: number };
};

export const ActiveStateData = ({ data }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Flex align="center">
        <Button className={styles.labelIcon} variant="filled" color="green" icon={<AntIcon type="sun" />} />

        <span style={{ fontSize: 21, paddingLeft: 8 }}>{t("dashboard.statisticsExtended.activeState")}</span>
      </Flex>

      <Flex justify="center" style={{ height: STATS_HEIGHT }} className="margin-top-medium">
        <div>
          <Flex align="end">
            <StatNumber value={data.commissionsActiveStatePoints} />

            <span style={{ paddingLeft: 8, lineHeight: "34px" }}>
              {t("dashboard.statisticsExtended.helpers.points")}
            </span>
          </Flex>
        </div>
      </Flex>
    </>
  );
};
